'use client';
import React, { FC } from 'react';
import { TabHeaderConfig } from '~/definitions/tab';
import ToggledMenu from '../Header/ToggledMenu';
import ElectionYear from '../Header/ElectionYear';

interface Props {
    tabHeader: TabHeaderConfig[];
    isMenuOpened: boolean;
}

const TabHeader: FC<Props> = (props) => {
    const tabHeaderStyle =
        'text-left lg:text-center w-full lg:w-auto hover:bg-custom-gray-01 lg:hover:bg-white transition-colors duration-150 ease-in-out text-[#000] border-custom-gray-01 lg:rounded-t lg:border-t lg:border-l lg:border-r lg:mb-[-1px] border-b mr-[2px] py-2 px-4 lg:px-[10px] lg:py-[3px] no-underline';
    const normalStyle = `${tabHeaderStyle} bg-custom-gray-02 lg:bg-custom-gray-01 cursor-pointer`;
    const activeStyle = `${tabHeaderStyle} bg-custom-gray-01 lg:bg-[#fff]`;
    const disabled = `${tabHeaderStyle} italic opacity-50 pointer-events-none bg-custom-gray-02 lg:bg-custom-gray-01 border-b border-custom-gray-01`;
    const menuStyle =
        'bg-custom-gray-04 lg:bg-transparent list-none p-0 m-0 flex mb-[-1px] flex-col lg:flex-row absolute z-50 left-[0] right-[0] lg:static w-full overflow-hidden transition-[max-height] duration-[350ms] ease-[ease]';
    const openMenuStyle = `${menuStyle} lg:max-h-none max-h-[301px] border-b-[5px] border-b-[#0c0d0e] lg:border-b-0`;
    const closeMenuStyle = `${menuStyle} lg:max-h-none max-h-[0]`;
    const handleMenuStyle = props.isMenuOpened ? openMenuStyle : closeMenuStyle;

    return (
        <div className="bg-[#f7f7f7] pt-[8px] lg:border-b border-custom-gray-03 border-t border-t-[#fff] relative mb-[30px] bg-repeat-x bg-[url('/elements/bg/bg-top-menu.png')]">
            <div id="main-nav" className="responsive-main-container w-full ml-auto mr-auto lg:pt-[0.5rem]">
                <ToggledMenu />
                <ElectionYear />
                <ul className={handleMenuStyle}>
                    {props.tabHeader.map((tab) => (
                        <li key={tab.id} id={`${tab.id}-tab`}>
                            <button
                                type="button"
                                aria-label={tab.name}
                                onClick={tab.onClick}
                                className={tab.isDisabled ? disabled : tab.isActive ? activeStyle : normalStyle}
                                disabled={tab.isDisabled}
                            >
                                {tab.name}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TabHeader;
